const Video = ({video, autoPlay=true, muted=true, loop=true}) => {
  return (
  <div className="video-container">
    <video className="video-el" src={video} autoPlay={autoPlay} muted={muted} loop={muted} />
  </div>
  )
}

export default Video;